import { postRequest } from '../../../shared/utils';

export async function getTbloptNeededIdService({ need, screenGridId }) {
  const body = {
    columns: ['id'],
    screenGridId,
    schema: 'npi',
    table: 'tblopt_needed',
    key: 'need',
    value: need,
  };

  const { data, errors } = await postRequest('/api/records', body);

  if (errors) {
    return { errors };
  }

  return data;
}
